<template>
    <div id="ChildInquires">
      <v-layout class="flex-column">
        <v-layout class="mt-2 mb-3">
          <v-flex>
            <v-btn fab absolute left class="ml-3 pf-btn-fab" @click="goBack">
              <v-icon>arrow_back</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12 class="text-xs-right">
            <v-btn class="pf-btn pf-btn-grey border-radius-10 box-shadow-none" @click="goBack">
              <v-icon size="16" class="pr-1">arrow_back_ios</v-icon>
              <div>Back</div>
            </v-btn>
          </v-flex>
        </v-layout>
        
        <v-layout class="flex-column px-2">
          <h3 class="mt-4 pf-font-18 font-weight-bold">Inquiries <span class="font-weight-light" v-if="child && child.name">/ {{ child.name }}</span></h3>
          <v-data-table :headers="inquiriesHeaders" :pagination.sync="inquiriesPagination" :items="(child.type === 'Individual' ? inquiries : getSiblingInquiries())" class="mt-4 pf-data-table">
            <template v-slot:items="props">
              <td>{{ formatDate(props.item.created_date) }}</td>
              <td>{{ props.item.parent1 }}{{ props.item.parent2 && props.item.parent2.trim() ? (', ' + props.item.parent2.trim()) : '' }}</td>
              <td>{{ props.item.state || props.item.State || '--' }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.phone }}</td>
              <!-- <td>{{ props.item.inquiry_status }}</td> -->
              <td>
                <v-select
                  v-model="props.item.inquiry_status"
                  :items="statusList"
                  height="30px"
                  @change="updateInquiryStatus($event, props.item)"
                ></v-select>
              </td>
              <td>
                <v-menu bottom left>
                  <template v-slot:activator="{ on }">
                    <v-btn class="pf-text-grey" icon v-on="on">
                      <v-icon size="22">apps</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile @click="viewInquiry(props.item)">
                      <v-list-tile-title>View Inquiry</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="deleteInquiry(props.item)">
                      <v-list-tile-title>Delete</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </td>
            </template>          
          </v-data-table>
        </v-layout>
      </v-layout>
      <app-modal :active="!!currentInquiry" v-if="!!currentInquiry" width="60%">
        <div slot="modal-content">
          <v-card>
            <v-toolbar card dark class="pf-bg-teal">
              <v-btn class="pf-modal-close" icon dark @click="closeInquiryDetails">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>Inquiry Details / {{ child.name }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="mt-4 mb-4" id="inquiryDetailsElement">
              <h3 class="pf-font-20 font-weight-bold text-xs-center mb-3">{{ child.name }} - {{ viewingInquiry.parent1 }} - {{ formatDate(viewingInquiry.created_date) }}</h3>
              <v-layout class="pa-2 flex-column">
                <v-flex class="inquiry-section">
                  <h3>Email Address</h3>
                  <v-flex class="my-3">
                    <v-layout wrap class="px-3 py-2">
                      <v-flex xs6>How did you hear about us ?</v-flex>
                      <v-flex xs6>{{ currentInquiry.Hear_About }}</v-flex>
                    </v-layout>
                    <v-layout wrap class="px-3 py-2">
                      <v-flex xs6>Please enter your email address</v-flex>
                      <v-flex xs6>
                        <a :href="`mailto:${currentInquiry.AP1Email}`">{{ currentInquiry.AP1Email }}</a>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>

                <v-flex class="inquiry-section">
                  <h3>Contact</h3>
                  <v-flex class="my-3">
                    <v-layout wrap class="px-3 py-2">
                      <v-flex xs6>Full name:</v-flex>
                      <v-flex xs6>{{ currentInquiry.AP1Fname }}{{ currentInquiry.AP1Lname ? (' ' + currentInquiry.AP1Lname) : '' }}</v-flex>
                    </v-layout>
                    <v-layout wrap class="px-3 py-2">
                      <v-flex xs6>Phone:</v-flex>
                      <v-flex xs6>
                        <a :href="`tel:${currentInquiry.AP1CellPhone}`">{{ currentInquiry.AP1CellPhone }}</a>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>

                <v-flex class="inquiry-section" v-if="currentInquiry.AP2Fname">
                  <h3>Person 2</h3>
                  <v-flex class="my-3">
                    <v-layout wrap class="px-3 py-2">
                      <v-flex xs6>Full name:</v-flex>
                      <v-flex xs6>{{ currentInquiry.AP2Fname }}{{ currentInquiry.AP2Lname ? (' ' + currentInquiry.AP2Lname) : '' }}</v-flex>
                    </v-layout>
                    <v-layout wrap class="px-3 py-2" v-if="currentInquiry.AP2CellPhone">
                      <v-flex xs6>Phone:</v-flex>
                      <v-flex xs6>
                        <a :href="`tel:${currentInquiry.AP2CellPhone}`" v-if="currentInquiry.AP2CellPhone">{{ currentInquiry.AP2CellPhone }}</a>
                        <span v-else>--</span>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap class="px-3 py-2" v-if="currentInquiry.AP2Email">
                      <v-flex xs6>Email:</v-flex>
                      <v-flex xs6>
                        <a :href="`mailto:${currentInquiry.AP2Email}`">{{ currentInquiry.AP2Email }}</a>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>

                <v-flex class="inquiry-section">
                  <h3>Address</h3>
                  <v-flex class="my-3">
                    <v-layout wrap class="px-3 py-2">
                      <v-flex xs6>Address line 1:</v-flex>
                      <v-flex xs6>{{ currentInquiry.Add1 }}</v-flex>
                    </v-layout>
                    <v-layout wrap class="px-3 py-2">
                      <v-flex xs6>Address line 2:</v-flex>
                      <v-flex xs6>{{ currentInquiry.Add2 || '--' }}</v-flex>
                    </v-layout>
                    <v-layout wrap class="px-3 py-2">
                      <v-flex xs6>City:</v-flex>
                      <v-flex xs6>{{ currentInquiry.City }}</v-flex>
                    </v-layout>
                    <v-layout wrap class="px-3 py-2">
                      <v-flex xs6>State:</v-flex>
                      <v-flex xs6>{{ currentInquiry.State }}</v-flex>
                    </v-layout>
                    <v-layout wrap class="px-3 py-2">
                      <v-flex xs6>Country:</v-flex>
                      <v-flex xs6>{{ currentInquiry.Country }}</v-flex>
                    </v-layout>
                    <v-layout wrap class="px-3 py-2">
                      <v-flex xs6>ZIP:</v-flex>
                      <v-flex xs6>{{ currentInquiry.Zip }}</v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>

                <div class="html2pdf__page-break"></div>

                <v-flex class="inquiry-section mt-2">
                  <h3>Trainings</h3>
                  <v-flex class="my-3">
                    <v-layout v-if="!currentInquiry.trainings || !currentInquiry.trainings.length" wrap class="px-3 py-2">
                      <v-flex xs6>Completed trainings:</v-flex>
                      <v-flex xs6>None</v-flex>
                    </v-layout>
                    <v-flex class="pf-training-section" :class="{ 'mt-2': currentInquiry.trainings.length > 3 && t === 3 }" v-for="(training, t) in currentInquiry.trainings" :key="t">
                      <v-layout wrap class="px-3 py-2">
                        <v-flex xs6>Name:</v-flex>
                        <v-flex xs6>{{ training.name || 'None' }}</v-flex>
                      </v-layout>
                      <v-layout wrap class="px-3 py-2">
                        <v-flex xs6>Completion date:</v-flex>
                        <v-flex xs6>{{ training.completion_date ? formatDate(training.completion_date) : 'None' }}</v-flex>
                      </v-layout>
                      <v-layout wrap class="px-3 py-2">
                        <v-flex xs6>Training organization name:</v-flex>
                        <v-flex xs6>{{ training.institute || 'None' }}</v-flex>
                      </v-layout>
                      <v-layout wrap class="px-3 py-2">
                        <v-flex xs6>Training contact name:</v-flex>
                        <v-flex xs6>{{ training.contact_name || 'None' }}</v-flex>
                      </v-layout>
                      <v-layout wrap class="px-3 py-2">
                        <v-flex xs6>Training contact email:</v-flex>
                        <v-flex xs6>
                          <a v-if="training.contact_email" :href="`mailto:${training.contact_email}`">{{ training.contact_email }}</a>
                          <span v-else>None</span>
                        </v-flex>
                      </v-layout>
                      <v-layout wrap class="px-3 py-2">
                        <v-flex xs6>Training contact phone number:</v-flex>
                        <v-flex xs6>
                          <a v-if="training.contact_phone" :href="`tel:${training.contact_phone}`">{{ training.contact_phone }}</a>
                          <span v-else>None</span>
                        </v-flex>
                      </v-layout>
                      <v-layout wrap class="px-3 py-2">
                        <v-flex xs6>Training document:</v-flex>
                        <v-flex xs6>
                          <span v-if="training.file_path" class="download-link" @click="downloadFile(training.file_path, `training_${training.name}`)">Download</span>
                          <span v-else>None</span>
                        </v-flex>
                      </v-layout>
                      <div class="html2pdf__page-break" v-if="currentInquiry.trainings.length > 3 && t === 2"></div>
                    </v-flex>
                  </v-flex>
                </v-flex>

                <div class="html2pdf__page-break"></div>

                <v-flex class="inquiry-section mt-2">
                  <h3>Home Study</h3>
                  <v-flex class="my-3">
                    <!-- <v-layout wrap class="px-3 py-2 mt-2">
                      <v-flex xs6>Have you completed a Parenting course?</v-flex>
                      <v-flex xs6>{{ currentInquiry.done_course }}</v-flex>
                    </v-layout>
                    <v-layout wrap class="px-3 py-2" v-if="currentInquiry.done_course === 'Yes'">
                      <v-flex xs6>Date of Completion:</v-flex>
                      <v-flex xs6>{{ formatDate(currentInquiry.done_course_date) }}</v-flex>
                    </v-layout>
                    <v-layout wrap class="px-3 py-2">
                      <v-flex xs6>Please upload your PPT/MAPP Certificate:</v-flex>
                      <v-flex xs6>
                        <span v-if="currentInquiry['PPT-MAPPCertificate']" class="download-link" @click="downloadFile(currentInquiry['PPT-MAPPCertificate'], 'ppt-mapp')">Download</span>
                        <span v-else>None</span>
                      </v-flex>
                    </v-layout> -->
                    <v-layout wrap class="px-3 py-2">
                      <v-flex xs6>Do you have a current completed and signed Adoption Home Study for Adoption from Foster Care?</v-flex>
                      <v-flex xs6>{{ currentInquiry.done_home_study }}</v-flex>
                    </v-layout>
                    <template v-if="currentInquiry.done_home_study === 'Yes' && currentInquiry.homeStudy">
                      <v-layout wrap class="px-3 py-2">
                        <v-flex xs6>Home study document:</v-flex>
                        <v-flex xs6>
                          <span v-if="currentInquiry['AdoptionHomestudy']" class="download-link" @click="downloadFile(currentInquiry['AdoptionHomestudy'], 'homestudy')">Download</span>
                          <span v-else>None</span>
                        </v-flex>
                      </v-layout>
                      <v-layout wrap class="px-3 py-2">
                        <v-flex xs6>Date of completion:</v-flex>
                        <v-flex xs6>{{ formatDate(currentInquiry.homeStudy.completion_date) }}</v-flex>
                      </v-layout>
                      <v-layout wrap class="px-3 py-2">
                        <v-flex xs6>Organization name:</v-flex>
                        <v-flex xs6>{{ currentInquiry.homeStudy.institute }}</v-flex>
                      </v-layout>
                      <v-layout wrap class="px-3 py-2">
                        <v-flex xs6>Contact name:</v-flex>
                        <v-flex xs6>{{ currentInquiry.homeStudy.contact_name }}</v-flex>
                      </v-layout>
                      <v-layout wrap class="px-3 py-2">
                        <v-flex xs6>Contact email:</v-flex>
                        <v-flex xs6>
                          <a :href="`mailto:${currentInquiry.homeStudy.contact_email}`">{{ currentInquiry.homeStudy.contact_email }}</a>
                        </v-flex>
                      </v-layout>
                      <v-layout wrap class="px-3 py-2">
                        <v-flex xs6>Contact phone number:</v-flex>
                        <v-flex xs6>
                          <a :href="`tel:${currentInquiry.homeStudy.contact_phone}`">{{ currentInquiry.homeStudy.contact_phone }}</a>
                        </v-flex>
                      </v-layout>
                    </template>
                    <!-- <v-layout wrap class="px-3 py-2">
                      <v-flex xs6>AARC needed?</v-flex>
                      <v-flex xs6>{{ currentInquiry.aarc }}</v-flex>
                    </v-layout>
                    <v-layout wrap class="px-3 py-2" v-if="currentInquiry.aarc === 'Yes'">
                      <v-flex xs6>Why is AARC needed?</v-flex>
                      <v-flex xs6>{{ currentInquiry.aarc_why }}</v-flex>
                    </v-layout> -->
                  </v-flex>
                </v-flex>

                <v-flex class="inquiry-section mt-2">
                  <h3>Additional Information</h3>
                  <v-flex class="my-3">
                    <v-layout wrap class="px-3 py-2">
                      <v-flex xs6>Comments or Questions:</v-flex>
                      <v-flex xs6>{{ currentInquiry.comments }}</v-flex>
                    </v-layout>
                    <v-layout wrap class="px-3 py-2">
                      <v-flex xs6>Other supportive documention:</v-flex>
                      <v-flex xs6>
                        <span v-if="currentInquiry['SupportiveDocumentation']" class="download-link" @click="downloadFile(currentInquiry['SupportiveDocumentation'], 'supportive-doc')">Download</span>
                        <span v-else>None</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>
                
                <h3 class="preference-title mt-2">Preferences</h3>
                <v-flex class="inquiry-section" v-for="(section, s) in preferenceFields" :key="s">
                  <h3>{{ section.title }}</h3>
                  <v-flex class="my-3">
                    <v-layout wrap class="px-3 py-2" v-for="(field, f) in section.items" :key="`${s}2${f}`">
                      <v-flex xs6>{{ field.label }}:</v-flex>
                      <v-flex xs6>{{ currentInquiry[field.id] ? preferenceTexts[currentInquiry[field.id]] : 'None' }}</v-flex>
                      <div class="html2pdf__page-break" v-if="['IC2_4', 'IC5_26', 'IC7_47', 'IC8_70', 'IC10_86', 'IC12_109', 'IC13_134'].indexOf(field.id) > -1"></div>
                    </v-layout>
                  </v-flex>
                </v-flex>

              </v-layout>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="pa-3">
              <v-spacer></v-spacer>
              <v-btn
                class="pf-btn-text-white pf-bg-green"
                @click="downloadInquiry"
              >
                Download
              </v-btn>
              <v-btn
                class="pf-btn-text-white pf-bg-pink"
                @click="closeInquiryDetails"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </app-modal>
    </div>
</template>
<script>
/* global session store config */
/* eslint complexity: ["error", 22] */
import swal from 'sweetalert2';
import { formatDate, request, getCollection, getFileExtension, remove, validateUrl, checkIfNoPFUrl } from '../../helpers/helpers';
import AppModal from '../../components/AppModal';
import html2pdf from 'html2pdf.js';
import { saveAs } from 'file-saver';

export default {
  components: {
    'app-modal': AppModal
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    child: {
      type: Object,
      default: null
    }
  },
  data: vm => ({
    formatDate,
    inquiriesHeaders: [
      { text: 'Date', value: 'created_date' },
      { text: 'Name', value: 'name' },
      { text: 'State', value: 'state' },
      { text: 'Email', value: 'email' },
      { text: 'Phone', value: 'phone' },
      { text: 'Status', value: 'inquiry_status', width: '100px' },
      { text: 'Actions', value: '' }
    ],
    inquiriesPagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: 'created_date',
      descending: true
    },
    agencyAddress: {
      line_1: '',
      line_2: '',
      city: '',
      country: '',
      state: '',
      zip: '',
      email: '',
      phone: '',
      website: '',
    },
    inquiries: [],
    inquiriesBackup: [],
    currentInquiry: null,
    viewingInquiry: null,
    fileTypes: ['Supportive Documentation', 'Adoption Homestudy', 'PPT-MAPP Certificate'],
    inquiryDetails: {},
    preferenceTexts: {
      'P': 'Preferred',
      'A': 'Acceptable',
      'WC': 'Would Consider',
      'U': 'Unacceptable'
    },
    statusList: ['New', 'Completed'],
    preferenceFields: [
      {
        title: 'Gender of Child',
        items: [
          { label: 'Male', id: 'IC1_1', value: '' },
          { label: 'Female', id: 'IC1_2', value: '' }
        ]
      },
      {
        title: 'Race/Ethnicity/Culture of Child',
        items: [
          { label: 'A child of the same Racial / Ethnic/Cultural background as that of the family', id: 'IC2_3', value: '' },
          { label: 'A child of the different Racial/Ethnic/Cultural background as that of the family', id: 'IC2_4', value: '' },
          { label: 'A child of any Racial/Ethnic/Cultural background', id: 'IC2_5', value: '' },
          // { label: 'Race', id: 'IC2_6', value: '' }
        ]
      },
      {
        title: 'Number/Type of Children',
        items: [
          { label: 'One Child', id: 'IC3_7', value: '' },
          { label: 'Two Children', id: 'IC3_8', value: '' },
          { label: 'Three Children', id: 'IC3_9', value: '' },
          { label: 'Four or More Children', id: 'IC3_10', value: '' },
          { label: 'Teen Parent with Child', id: 'IC3_11', value: '' },
        ]
      },
      {
        title: 'Age of Child',
        items: [
          { label: '0-2 Years of Age', id: 'IC4_12', value: '' },
          { label: '3-5 Years of Age', id: 'IC4_13', value: '' },
          { label: '6-8 Years of Age', id: 'IC4_14', value: '' },
          { label: '9-11 Years of Age', id: 'IC4_15', value: '' },
          { label: '12 or Older', id: 'IC4_16', value: '' },
        ]
      },
      {
        title: 'Health of Child',
        items: [
          { label: 'No Significant Health Problems', id: 'IC5_17', value: '' },
          { label: 'Allergies or Asthma (May Require Treatment)', id: 'IC5_18', value: '' },
          { label: 'Hyperactivity (May Require Treatment)', id: 'IC5_19', value: '' },
          { label: 'Speech Problems (May Require Treatment)', id: 'IC5_20', value: '' },
          { label: 'Hearing Problems (May Require Treatment)', id: 'IC5_21', value: '' },
          { label: 'Legally Deaf', id: 'IC5_22', value: '' },
          { label: 'Vision Problems (May Require Treatment)', id: 'IC5_23', value: '' },
          { label: 'Legally Blind', id: 'IC5_24', value: '' },
          { label: 'Dental Problems (May Require Treatment)', id: 'IC5_25', value: '' },
          { label: 'Orthopedic Disorder (May Require Treatments)', id: 'IC5_26', value: '' },
          { label: 'Seizure Disorder (May Require Treatments)', id: 'IC5_27', value: '' },
          { label: 'Other Medical Conditions Which May Require Treatment', id: 'IC5_28', value: '' }
        ]
      },
      {
        title: 'Education of Child',
        items: [
          { label: 'High Achiever', id: 'IC6_29', value: '' },
          { label: 'Achieving at Grade Level', id: 'IC6_30', value: '' },
          { label: 'Achieving Below Grade Level', id: 'IC6_31', value: '' },
          { label: 'Needs Special Education', id: 'IC6_32', value: '' },
          { label: 'Needs Emotional Handicapped Education', id: 'IC6_33', value: '' },
          { label: 'Needs Tutoring in One or More Subjects', id: 'IC6_34', value: '' },
          { label: 'Has Serious Behavior Problems at School', id: 'IC6_35', value: '' }
        ]
      },
      {
        title: 'Characteristics And Behavior of Child',
        items: [
          { label: 'Generally Quiet And Shy', id: 'IC7_36', value: '' },
          { label: 'Generally Outgoing And Noisy', id: 'IC7_37', value: '' },
          { label: 'Has Emotional Issues Requiring Therapy At Present', id: 'IC7_38', value: '' },
          { label: 'Has Tendency to Reject Father Figures', id: 'IC7_39', value: '' },
          { label: 'Has Tendency to Reject Mother Figures', id: 'IC7_40', value: '' },
          { label: 'Tends to Form Mostly Superficial Relationships', id: 'IC7_41', value: '' },
          { label: 'Has Difficulty Making Friends and Relating with Other Children', id: 'IC7_42', value: '' },
          { label: 'Frequently Wets Bed', id: 'IC7_43', value: '' },
          { label: 'Frequently Wets During the Day', id: 'IC7_44', value: '' },
          { label: 'Frquently Soils Him / Herself', id: 'IC7_45', value: '' },
          { label: 'Masturbates Frequently and / or Openly', id: 'IC7_46', value: '' },
          { label: 'Has Poor Social Skills', id: 'IC7_47', value: '' },
          { label: 'Has A Problem with Lying', id: 'IC7_48', value: '' },
          { label: 'Has A Problem with Stealing', id: 'IC7_49', value: '' },
          { label: 'Frequent Physical Altercations With Other Children', id: 'IC7_50', value: '' },
          { label: 'Tends to Abuse Animals', id: 'IC7_51', value: '' },
          { label: 'Tends to Be Destructive of Personal Property', id: 'IC7_52', value: '' },
          { label: 'Frequently Uses Language You Would Consider Inappropriate', id: 'IC7_53', value: '' },
          { label: 'Has Frequent Temper Tantrums', id: 'IC7_54', value: '' },
          { label: 'Has Difficulty Accepting and Obeying Rules', id: 'IC7_55', value: '' },
          { label: 'Has a History of Inappropriate Sexual Behavior', id: 'IC7_56', value: '' },
          { label: 'Has Sexual Identity and / or Trans-Gender Issues', id: 'IC7_57', value: '' },
          { label: 'Has a History of Running Away', id: 'IC7_58', value: '' },
          { label: 'Has a History of Setting Fires', id: 'IC7_59', value: '' },
          { label: 'Has A History of self Harm', id: 'IC7_60', value: '' }
        ]
      },
      {
        title: 'Family History',
        items: [
          { label: 'Has Strong Ties to Birth Family', id: 'IC8_61', value: '' },
          { label: 'Has Strong Ties To Foster Family', id: 'IC8_62', value: '' },
          { label: 'Will Need Continued Contact With Siblings in Adoptive Placement', id: 'IC8_63', value: '' },
          { label: 'Has Had a Previous Adoption Disruption', id: 'IC8_64', value: '' },
          { label: 'Has Been Physically Abused', id: 'IC8_65', value: '' },
          { label: 'Has Been Sexually Abused', id: 'IC8_66', value: '' },
          { label: 'Has Been Exposed To Promiscuous Behavior', id: 'IC8_67', value: '' },
          { label: 'Was Conceived As a Result of Rape', id: 'IC8_68', value: '' },
          { label: 'Was Conceived As a Result of Prostitution', id: 'IC8_69', value: '' },
          { label: 'One or Both Biological Parents Has Alcohol Addiction', id: 'IC8_70', value: '' },
          { label: 'One or Both Biological Parents Has Drug Dependency', id: 'IC8_71', value: '' },
          { label: 'One or Both Biological Parents Has A Criminal Record', id: 'IC8_72', value: '' },
          { label: 'One or Both Biological Parents Is/Are Mentally Handicapped', id: 'IC8_73', value: '' },
          { label: 'One or Both Biological Parents Has A Mental Illness', id: 'IC8_74', value: '' },
          { label: 'Agency Has No Information on One or Both Biological Parents', id: 'IC8_75', value: '' }
        ]
      },
      {
        title: 'Adoptive Family\'s Feeling Toward Openness',
        items: [
          { label: 'Is Willing To Meet Birth Parents', id: 'IC9_76', value: '' },
          { label: 'Is Willing To Have Contact With Birth Parents Through Intermediary', id: 'IC9_77', value: '' },
          { label: 'Is Willing to Send CorrespondenceTo Birth Parents', id: 'IC9_78', value: '' },
          { label: 'Is Willing To Receive Correspondence from Birth Parents', id: 'IC9_79', value: '' },
          { label: 'Is Willing To Have Child Continue Visitation With Siblings', id: 'IC9_80', value: '' },
          { label: 'Is Willing to Have Child Continue Visitation with Extended Relatives', id: 'IC9_81', value: '' },
          { label: 'Is Willing To Have Child Continue Visitation With Birth Parents', id: 'IC9_82', value: '' },
          { label: 'Is Willing To Receive Demographic Information About Birth Parents', id: 'IC9_83', value: '' },
          { label: 'Is Willing To Distribute Demographic Information To Birth Parents', id: 'IC9_84', value: '' }
        ]
      },
      {
        title: 'Mental Health',
        items: [
          { label: 'ADD/ADHD', id: 'IC10_85', value: '' },
          { label: 'Depression', id: 'IC10_86', value: '' },
          { label: 'Bi-polar Disorder', id: 'IC10_87', value: '' },
          { label: 'Schizophrenia', id: 'IC10_88', value: '' },
          { label: 'Reactive Attachment Disorder', id: 'IC10_89', value: '' },
          { label: 'Other mental health diagnoses', id: 'IC10_90', value: '' },
          { label: 'History of psychiatric hospitalizations', id: 'IC10_91', value: '' },
          { label: 'History of therapeutic foster care', id: 'IC10_92', value: '' },
          { label: 'Drug/Alcohol problems', id: 'IC10_93', value: '' }
        ]
      },
      {
        title: 'Behavioral',
        items: [
          { label: 'Tantrums', id: 'IC11_94', value: '' },
          { label: 'Property destruction', id: 'IC11_95', value: '' },
          { label: 'Physical aggression with peers and adults', id: 'IC11_96', value: '' },
          { label: 'History of sexual abuse', id: 'IC11_97', value: '' },
          { label: 'Sexually acting out', id: 'IC11_98', value: '' },
          { label: 'Masturbation', id: 'IC11_99', value: '' },
          { label: 'Perpetration', id: 'IC11_100', value: '' },
          { label: 'Promiscuity (sexualized behaviors)', id: 'IC11_101', value: '' },
          { label: 'Sexually Transmitted Disease', id: 'IC11_102', value: '' },
          { label: 'Behavioral concerns/issues', id: 'IC11_103', value: '' },
          { label: 'Truancy', id: 'IC11_104', value: '' },
          { label: 'DJJ History', id: 'IC11_105', value: '' },
          { label: 'Conduct Disorder', id: 'IC11_106', value: '' },
          { label: 'Oppositional Defiant Disorder', id: 'IC11_107', value: '' },
          { label: 'Other behavior disorder', id: 'IC11_108', value: '' }
        ]
      },
      {
        title: 'Developmental / Cognitive',
        items: [
          { label: 'Mild Mental retardation (IQ 60-69)', id: 'IC12_109', value: '' },
          { label: 'Moderate/Profound MR [IQ below 60]', id: 'IC12_110', value: '' },
          { label: 'Down Syndrome', id: 'IC12_111', value: '' },
          { label: 'Autism Spectrum Disorder', id: 'IC12_112', value: '' },
          { label: 'Learning Disability', id: 'IC12_113', value: '' },
          { label: 'Speech/Motor/Communication', id: 'IC12_114', value: '' }
        ]
      },
      {
        title: 'Medical',
        items: [
          { label: 'Cerebral Palsy', id: 'IC13_115', value: '' },
          { label: 'Deaf/ hearing difficulties', id: 'IC13_116', value: '' },
          { label: 'Blind', id: 'IC13_117', value: '' },
          { label: 'Non-ambulatory [wheelchair bound]', id: 'IC13_118', value: '' },
          { label: 'Scoliosis', id: 'IC13_119', value: '' },
          { label: 'Enuresis/Encopresis', id: 'IC13_120', value: '' },
          { label: 'Feeding problems (G-Tube)', id: 'IC13_121', value: '' },
          { label: 'Diabetes', id: 'IC13_122', value: '' },
          { label: 'Sleep disorders', id: 'IC13_123', value: '' },
          { label: 'Asthma', id: 'IC13_124', value: '' },
          { label: 'HIV positive', id: 'IC13_125', value: '' },
          { label: 'HIV exposed', id: 'IC13_126', value: '' },
          { label: 'Other blood disorder', id: 'IC13_127', value: '' },
          { label: 'Heart defects/problems', id: 'IC13_128', value: '' },
          { label: 'Physical malformations', id: 'IC13_129', value: '' },
          { label: 'Glasses/visual problems', id: 'IC13_130', value: '' },
          { label: 'Speech problems', id: 'IC13_131', value: '' },
          { label: 'Spina Bifida', id: 'IC13_132', value: '' },
          { label: 'Cleft Lip', id: 'IC13_133', value: '' },
          { label: 'Hereditary/Genetic disorder, which may not appear until late childhood or adulthood', id: 'IC13_134', value: '' },
          { label: 'Fetal alcohol syndrome', id: 'IC13_135', value: '' },
          { label: 'History of drug/alcohol exposure/addiction at birth', id: 'IC13_136', value: '' },
          { label: 'A child questioning their sexual orientation', id: 'IC13_137', value: '' },
          { label: 'A child questioning their gender (transgender issues)', id: 'IC13_138', value: '' },
          { label: 'Animal Abuse', id: 'IC13_139', value: '' },
          { label: 'Fire Setting', id: 'IC13_140', value: '' }
        ]
      }
    ],
    choices: [
      { text: 'Preferred', value: 'P' },
      { text: 'Acceptable', value: 'A' },
      { text: 'Would Consider', value: 'WC' },
      { text: 'Unacceptable', value: 'U' }
    ],
  }),
  computed: {
    filteredStates () {
      let countryId = this.agencyAddress.country ? this.agencyAddress.country : null;
      let options = this.State;
      return countryId ? options.filter(o => o.country.id === countryId) : options;
    },
    states () {
      return this.State.filter(o => o.country.id === '5f0af2eb1b61360afbb1aa0c');
    },
    Country: {
      get () {
        return store.state.Country;
      },
      set (value) {
        store.commit('setCountry', value);
      }
    }, 
    State: {
      get () {
        return store.state.State;
      },
      set (value) {
        store.commit('setState', value);
      }
    },
    Child: {
      get () {
        return store.state.Child;
      },
      set (value) {
        store.commit('setChild', value);
      }
    },
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    },
  },
  async created () {
    if (this.data && this.data.length) {
      this.inquiries = this.data;
      this.inquiriesBackup = JSON.parse(JSON.stringify(this.data));
    } else if (this.child) {
      this.fetchInquiries();
    }
    this.initializeCountry();
    this.initializeState();
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    async initializeCountry () {
      if (!this.Country.length) {
        let sort = { name: 1 };
        let { error, data } = await getCollection('Country', true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.Country = data;
          }
        }
      }
    },
    async initializeState () {
      if (!this.State.length) {
        let sort = { name: 1 };
        let { error, data } = await getCollection('State', true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.State = data;
          }
        }
      }
    },
    getAgencyState (inquiry) {
      if (inquiry && inquiry.badge_identifier) {
        const agency = this.AgencyList.find(x => x.map_sub_id && x.map_sub_id.toString() === inquiry.badge_identifier.toString());
        return agency && agency.address && agency.address.length ? (agency.address[0].state && agency.address[0].state.name ? agency.address[0].state.name : '--') : '--';
      }
      return '--';
    },
    goBack () {
      this.$emit('back');
    },
    getSiblingInquiries () {
      const inquiries = this.inquiriesBackup.filter(x => x.is_sibling);
      if (inquiries.length) {
        // Define a Set to store unique values
        const uniqueValuesSet = [];
        const uniqueInquiries = [];
  
        // Iterate through the array and add unique values to the Set
        for (const obj of inquiries) {
          if (obj.uuid) {
            if (uniqueValuesSet.indexOf(obj.uuid) === -1) {
              uniqueValuesSet.push(obj.uuid);
              uniqueInquiries.push(obj);
            }
          } else {
            uniqueInquiries.push(obj);
          }
        }
        return uniqueInquiries;
      }
      return [];
    },
    async updateInquiryStatus (newStatus, inquiry) {
      try {
        let payload = JSON.parse(JSON.stringify(inquiry));
        payload.inquiry_status = newStatus;
        let { data, error } = await request(`ChildGroup/Inquiry/${inquiry.id}`, 'PUT', payload);
        if (error) {
          swal.fire({
            type: 'error',
            title: 'Error',
            text: error || 'Failed to process the request, please try again',
            showConfirmButton: true
          });
        }
      } catch (e) {
        console.log(e);
        swal.fire({
          type: 'error',
          title: 'Error',
          text: e.message || 'Failed to process the request, please try again',
          showConfirmButton: true
        });
      }
    },
    async deleteInquiry (item) {
      let removeItem = JSON.parse(JSON.stringify(item));
      swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to revert this back!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            try {
              let { data, error } = await request(`ChildGroup/Inquiry/${removeItem.id}`, 'DELETE');
              if (error) {
                swal.fire({
                  type: 'error',
                  title: 'Error',
                  text: error || 'Failed to process the request, please try again',
                  showConfirmButton: true
                });
              } else {
                const index = this.inquiries.findIndex(x => x.id === removeItem.id);
                if (index > -1) {
                  this.inquiries.splice(index, 1);
                  this.inquiriesBackup = JSON.parse(JSON.stringify(this.inquiries));
                }
              }
            } catch (e) {
              console.log(e);
              swal.fire({
                type: 'error',
                title: 'Error',
                text: e.message || 'Failed to process the request, please try again',
                showConfirmButton: true
              });
            }
          })();
        }
      });
    },
    async fetchInquiries () {
      if (!this.inquiries.length && this.child.child && this.child.child.length && this.child.child[0].child && this.child.child[0].child.map_data) {
        let where = {
          childId: this.child.child.filter(x => x.child && x.child.map_data && x.child.map_data.user_id).map(x => x.child.map_data.user_id).join(','),
          agency: this.child.agency.id
        };
        let { error, data } = await getCollection('ChildGroup/Inquiries', true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          this.inquiries = data;
          this.inquiriesBackup = JSON.parse(JSON.stringify(this.inquiries));
        }
      }
    },
    async viewInquiry (inquiry) {
      if (!inquiry || !inquiry.id) {
        return;
      }
      this.viewingInquiry = inquiry;
      let tempInquiry = null;
      if (this.inquiryDetails[inquiry.id]) {
        tempInquiry = this.inquiryDetails[inquiry.id];
      } else {
        // Fetch the inquiry details
        let { data, error } = await request(`ChildGroup/Inquiry/${inquiry.id}`, 'GET');
        if (error) {
          swal.fire({
            type: 'warning',
            title: '<b>Error</b>',
            text: error || 'Failed to fetch the details',
            showConfirmButton: true
          });
        } else {
          tempInquiry = data;
          this.inquiryDetails[inquiry.id] = data;
        }
      }
      if (tempInquiry) {
        this.currentInquiry = {};
        for (let item of tempInquiry.general_info) {
          this.currentInquiry[item.field_name] = item.field_value;
        }
        for (let item of tempInquiry.preferences) {
          this.currentInquiry[item.QuestionCode] = item.Answer;
        }
        if (tempInquiry.documents && tempInquiry.documents.length) {
          for (let type of this.fileTypes) {
            const doc = tempInquiry.documents.find(x => x.description === type);
            // Set the home study
            if (type === 'Adoption Homestudy') {
              this.currentInquiry.homeStudy = doc;
            }
            if (doc && doc.file_name && doc.file_path) {
              this.currentInquiry[type.replace(/\s/g, '')] = `${config.map.cdn}${doc.file_path}${doc.file_name}`;
            }
          }
        }
        if (tempInquiry.trainings && tempInquiry.trainings.length) {
          this.currentInquiry.trainings = tempInquiry.trainings.map(t => {
            t.file_path = `${config.map.cdn}${t.file_path}`;
            return t;
          });
        }
      }
    },
    closeInquiryDetails () {
      this.viewingInquiry = null;
      this.currentInquiry = null;
    },
    downloadFile (url, type) {
      if (!url || !type) {
        return;
      }
      const realUrl = url.substr(0, url.lastIndexOf('.'));
      const ext = getFileExtension(realUrl);
      if (!ext) {
        return;
      }
      const filename = `${this.child.name}-${type}.${ext}`;
      saveAs(url, filename);
    },
    downloadInquiry () {
      const element = document.getElementById('inquiryDetailsElement');
      const filename = `${this.child.name} - ${this.viewingInquiry.parent1} - ${formatDate(this.viewingInquiry.created_date)}`;

      // Configuration for html2pdf
      const options = {
        margin: 10,
        filename: `Inquiry - ${filename}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      };

      try {
        // Use html2pdf to generate PDF from HTML content
        html2pdf().from(element).set(options).save();
      } catch (e) {
        console.log('Download error', e);
      }

    }
  }
};
</script>

<style>
.header-style {
  background: #F195BF;
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/pages/Children/Inquiries.vue